@use '@design/design-tokens/border-radius/border-radius' as *;

@layer chart {
  .chipHorizonSelectorRoot {
    display: flex;
    @include border-radius-r2;
    padding: 4px;
    background-color: var(--surface-default);
    gap: 4px;

    button {
      text-transform: uppercase;
    }
  }
}
